export default __webpack_public_path__ + "static/wallpaper-2-mb-05f9e5e088c78ed5370efd8570d1b4f7.png";